import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import cn from 'classnames';

import { Loader } from '../../../components/Loader';

import { HBox, VBox } from '../../../components/Box';
import { List, Row } from '../../../components/List';

import { getPropByName } from '../../../utils/props';
import { fetchVehicle } from '../../Vehicles/actions';
import { selectUser } from '../../Users/selectors';
import { selectWorks } from '../../Api/selectors';
import { REQUEST_VEHICLE, REQUEST_VEHICLE_PROPERTY_UPDATE } from '../../Vehicles/constants';
import { REQUEST_USER } from '../../Users/constants';
import { selectVehicle, selectVehicleTasks } from '../../Vehicles/selectors';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import { getRemarkType } from '../../KanbanBoards/cells/helpers/getRemarkType';

dayjs.extend(customParseFormat);
const Container = styled.div`
  font-size: 14px;
  width: ${props => (props.vehicleTaskRemarks ? '100%' : '')};

  align-items: center;

  .readMore {
    cursor: pointer;
  }

  .remark {
    margin-bottom: 10px;
    min-height: 60px;

    .initials-wrapper {
      width: 40px;
      height: 40px;
      background-color: rgba(29, 155, 209, 0.1);
      justify-content: center;
      border-radius: 50%;
    }

    .text {
      width: 85%;
      text-align: start;
    }
  }
`;

const STATE = {
  isOpenAddModal: false,
  remarks: [],
  newRemarkText: '',
  editableRemark: null,
};
/* eslint-disable react/prefer-stateless-function */
class TaskRemarksTooltipComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    // const { fetchedVehicle, tasks, department } = this.props;

    // if (fetchedVehicle?.id) {
    //   const taskNames = tasks[department].map(task => getRemarkType(task?.name));

    //   const foundRemarks = taskNames
    //     .map(taskName => getPropByName(fetchedVehicle, taskName))
    //     .filter(Boolean)
    //     .map(JSON.parse);

    //   if (foundRemarks.length) {
    //     this.setState({ remarks: foundRemarks.flat() });
    //   }
    //   return;
    // }

    // this.props.fetchVehicle(result => {
    //   if (result?.id) {
    //     const taskNames = tasks[department].map(task => getRemarkType(task?.name));

    //     const foundRemarks = taskNames
    //       .map(taskName => getPropByName(result, taskName))
    //       .filter(Boolean)
    //       .map(JSON.parse);

    //     if (foundRemarks.length) {
    //       this.setState({ remarks: foundRemarks.flat() });
    //     }
    //   }
    // });

    if (this.props.fetchedVehicle?.id) {
      getPropByName(this.props.fetchedVehicle, this.remarksType) &&
        this.setState({ remarks: JSON.parse(getPropByName(this.props.fetchedVehicle, this.remarksType)) });

      return;
    }
    this.props.fetchVehicle(result => {
      if (result?.id) {
        getPropByName(this.vehicle, this.remarksType) &&
          this.setState({ remarks: JSON.parse(getPropByName(this.vehicle, this.remarksType)) });
      }
    });
  }

  get vehicle() {
    return this.props.vehicle;
  }

  get remarkDate() {
    return dayjs(new Date(Date.now())).format('DD-MM-YYYY HH:mm');
  }

  get sortingDate() {
    return new Date(Date.now());
  }

  get remarksType() {
    return getRemarkType(this.props.taskName);
  }

  get sortedRemarks() {
    return Array.isArray(this.state.remarks)
      ? [...this.state.remarks].sort((a, b) => (b.sortingDate < a.sortingDate ? -1 : 1))
      : [];
  }

  get lastAddedRemark() {
    return Array.isArray(this.state.remarks)
      ? [...this.state.remarks].sort((a, b) => (b?.sortingDate < a?.sortingDate ? -1 : 1))[0]
      : null;
  }

  scrollToCard2() {
    const CardVehicleTasksRemarks = document.getElementById('CardVehicleTasksRemarks');

    if (CardVehicleTasksRemarks) {
      CardVehicleTasksRemarks.scrollIntoView({ behavior: 'smooth' });
    }
  }

  renderInitials(name, surname) {
    return (
      <HBox vCenter>
        <HBox className="initials-wrapper" vCenter left>
          <strong>{name[0]?.toUpperCase()}</strong>
          <strong>{surname[0]?.toUpperCase()}</strong>
        </HBox>
        &nbsp;
        <HBox vCenter right>
          <strong>{name ?? ''}</strong>
          &nbsp;
          <strong>{surname ?? ''}</strong>
        </HBox>
      </HBox>
    );
  }

  reset() {
    this.setState({ isOpenAddModal: false, newRemarkText: '', editableRemark: null });
  }

  renderRemarks(isModal) {
    const remark = this.lastAddedRemark;
    const nl2br = text => {
      return { __html: text?.replace(/(?:\r\n|\r|\n)/g, '<br>') };
    };

    return (
      <List isModal={isModal} onClose={() => this.setState({ showRemarksList: false })}>
        {this.state.remarks?.map(remark => (
          <div key={remark?.id}>
            <VBox className="remark" vCenter>
              {remark?.name && remark?.surname && this.renderInitials(remark?.name, remark?.surname)}
              <p className="text" dangerouslySetInnerHTML={nl2br(remark?.text)}></p>
            </VBox>
            <HBox right>{remark?.date}</HBox>
          </div>
        ))}
      </List>
    );
  }

  render() {
    if (this.props.work) return <Loader small />;
    if (!this.remarksType) return null;
    if (!this.state.remarks?.length) {
      return null;
    }

    return (
      <div className="alt-block">
        <Container vehicleTaskRemarks>{this.renderRemarks(false)}</Container>
      </div>
    );
  }
}

TaskRemarksTooltipComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([
      REQUEST_USER,
      `${REQUEST_VEHICLE_PROPERTY_UPDATE}-${getRemarkType(ownProps.taskName)}`,
      REQUEST_VEHICLE_PROPERTY_UPDATE,
      REQUEST_VEHICLE,
    ]),
    loggedUser: selectUser(ownProps?.loggedUserId),
    vehicle: selectVehicle(ownProps.vehicleId),
    tasks: selectVehicleTasks(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetchVehicle(callback) {
      dispatch(fetchVehicle(ownProps.vehicleId, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const TaskRemarksTooltip = compose(withConnect, withRouter)(TaskRemarksTooltipComp);
